const childsilhouette = (props={}) =>{
  if(props.gender==="Male" || props.gender==="male")

      return "https://wvusstatic.com/2018/childsilhouette_boy.jpg";
      else {
        return "https://wvusstatic.com/2018/childsilhouette_girl.jpg";
      }

};

export const childImage = (props, childDetail) => {
  //if child detail page
  if (childDetail === true) {
    // console.log("childDetailfromhelper: ", props);
    if (props.childMedia && props.webPublishableFlag) {
      const obj = props.childMedia.find((x) => x.contentTypeCode === "CGP" && x.format === "web");
      //check if obj is defined
      if(obj== null){
        return childsilhouette(props);
      }
      else{
        return obj.url;
      }
    }
    else {
      return childsilhouette(props);
    }
  } 
  //grid view
  else {
    //if props has cgpUrl
    if(props.cgpUrl != null){
      return props.cgpUrl;
    }
    //if not, display silohoutte
    else{
      return childsilhouette(props);
    }
  }
};

export const donateEnvironment = (env) => {
  switch (env) {
    case "local":
      return "donatelocal";
    case "dev":
      return "donateqa1";
    case "qa1":
      return "donateqa1";
    case "qa2":
      return "donateqa2";
    case "stg":
      return "donatestg1";
    case "prod":
      return "donate";
    default:
      return "donateqa1";
  }
};

export const donateLinkBuilder = (props, failover=false, failoverCallbackUrl="", cswData={}) => {
  const birthday = new Date(props.childBrithday)
    .toISOString()
    .slice(0, 10)
    .replace(/-/g, "");

  let cswUtms = '';

  if(cswData.cswMode === true){
    cswUtms = `&utm_source=CSW&utm_medium=wvreferral&utm_campaign=${cswData['partnerSlug'] || null }`;
  }

  return `${window.WVUS_ENV_VARS.urls.donate}/singlepagecheckout/cart/addProducts?productid[]=${
    props.childId
  }&amt[]=39&childimage[]=${props.childImage}&productname[]=${props.childName}&countryname[]=${
    props.childCountry
  }&gender[]=${props.childGender}&birthdate[]=${birthday}${failover? "&nolock[]=true&callbackurl[]="+failoverCallbackUrl+props.childId :''}${cswUtms}`;
};

export const itemsNotEqual = (item1, item2, returnValue) => {
  if (Array.isArray(item1) && Array.isArray(item2)) {
    if (item1.length !== item2.length) {
      return returnValue;
    }
    for (var i = 0; i <= item1.length; i++) {
      if (item1[i] !== item2[i]) {
        // console.log(initialState.countryCodes, uiHasInteracted.countryCodes);

        return returnValue;
      }
    }
    return '';
  } else if (item1 !== item2) {
    return returnValue;
  }
  else {
    return '';
  }
};

export const addBodyClass = (className)=>{
  document.body.classList.add(className);
  document.documentElement.classList.add(className);
};

export const removeBodyClass = (className) =>{
  document.body.classList.remove(className);
  document.documentElement.classList.remove(className);
};

export const isInteractiveKeyCode = (e) => {
  const keyCode = e.keyCode;
  return keyCode === 13 || keyCode === 32;
};